var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7574 1.36529C12.1262 -0.186973 9.47106 -0.186973 7.83932 1.36494L7.50003 1.68721L7.16109 1.36509C5.52917 -0.187031 2.87443 -0.186855 1.24251 1.36509C0.44124 2.12722 0 3.1381 0 4.21125C0 5.28475 0.44124 6.29546 1.24263 7.05791L7.13771 12.6546C7.23911 12.7511 7.36966 12.7991 7.5 12.7991C7.63034 12.7991 7.76071 12.7509 7.86229 12.6544L13.7574 7.05791C14.5586 6.29563 15 5.28478 15 4.21143C15 3.13811 14.5586 2.12739 13.7574 1.36529ZM13.0321 6.29476L7.5 11.547L1.96808 6.29493C1.37771 5.73354 1.05264 4.99354 1.05264 4.21143C1.05264 3.42932 1.37771 2.68931 1.96808 2.12792C2.58387 1.54195 3.39264 1.24916 4.20158 1.24916C5.0107 1.24916 5.81982 1.5423 6.43562 2.12827L7.13736 2.79478C7.34051 2.98793 7.65929 2.98793 7.86246 2.79478L8.56438 2.12792C9.79614 0.956162 11.8002 0.956162 13.0319 2.12792C13.6221 2.68934 13.9474 3.42932 13.9474 4.21143C13.9474 4.99354 13.6221 5.73337 13.0321 6.29476Z",
    fill: "#696969"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.100738fe552ea16e772c3737eded8285.svg";
export { ForwardRef as ReactComponent };